'use client';

import { c as _c } from "react/compiler-runtime";
import { AppWindowIcon, BoxIcon, CopyIcon, PencilRulerIcon } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { EDITOR_VERSION, ENGINE_VERSION, PRODUCT_NAME } from '@/const';
interface AboutDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  appInfo: {
    appVersion: string;
    engineVersion: string;
    isDev: boolean;
  } | null;
}
export const AboutDialog = t0 => {
  const $ = _c(36);
  const {
    isOpen,
    onOpenChange,
    appInfo
  } = t0;
  if (!appInfo) {
    return null;
  }
  let t1;
  if ($[0] !== appInfo.appVersion || $[1] !== appInfo.engineVersion) {
    t1 = () => {
      const text = `SDK App - ${appInfo.appVersion}\nEditor - ${EDITOR_VERSION}\nEngine - ${appInfo.engineVersion}`;
      navigator.clipboard.writeText(text);
      toast.info("Copied to clipboard.");
    };
    $[0] = appInfo.appVersion;
    $[1] = appInfo.engineVersion;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleCopy = t1;
  const engineVersionMismatch = appInfo.engineVersion !== ENGINE_VERSION;
  let T0;
  let T1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[3] !== appInfo.appVersion || $[4] !== appInfo.engineVersion || $[5] !== appInfo.isDev || $[6] !== engineVersionMismatch || $[7] !== isOpen || $[8] !== onOpenChange) {
    const versionItems = [{
      label: "App/SDK",
      version: appInfo.appVersion,
      icon: AppWindowIcon
    }, {
      label: "Editor",
      version: EDITOR_VERSION,
      icon: PencilRulerIcon
    }, {
      label: "Engine",
      version: appInfo.engineVersion,
      icon: BoxIcon
    }];
    const renderVersion = (label, version) => {
      if (label === "Engine" && engineVersionMismatch) {
        const content = <span className="text-sm font-mono font-bold text-primary"><span className="text-destructive">{appInfo.engineVersion}</span></span>;
        return <Tooltip><TooltipTrigger asChild={true}>{content}</TooltipTrigger><TooltipContent>SDK and Editor engine version mismatch. Expected: {ENGINE_VERSION}</TooltipContent></Tooltip>;
      }
      return <span className="text-sm font-mono font-bold text-primary">{version}</span>;
    };
    T1 = Dialog;
    t6 = isOpen;
    t7 = onOpenChange;
    T0 = DialogContent;
    t4 = "max-w-sm";
    const t8 = appInfo.isDev ? " DEV" : "";
    if ($[17] !== t8) {
      t5 = <DialogHeader className="text-center"><DialogTitle className="text-sm font-medium">About {PRODUCT_NAME}{t8}</DialogTitle></DialogHeader>;
      $[17] = t8;
      $[18] = t5;
    } else {
      t5 = $[18];
    }
    t2 = "space-y-2 p-2";
    t3 = versionItems.map(t9 => {
      const {
        label: label_0,
        version: version_0,
        icon: Icon
      } = t9;
      return <div key={label_0} className="flex items-center justify-between rounded-lg bg-muted/50 px-4 py-2.5"><div className="flex items-center gap-2.5"><Icon className="size-4 text-foreground" /><span className="text-sm text-foreground">{label_0}</span></div>{renderVersion(label_0, version_0)}</div>;
    });
    $[3] = appInfo.appVersion;
    $[4] = appInfo.engineVersion;
    $[5] = appInfo.isDev;
    $[6] = engineVersionMismatch;
    $[7] = isOpen;
    $[8] = onOpenChange;
    $[9] = T0;
    $[10] = T1;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    T0 = $[9];
    T1 = $[10];
    t2 = $[11];
    t3 = $[12];
    t4 = $[13];
    t5 = $[14];
    t6 = $[15];
    t7 = $[16];
  }
  let t8;
  if ($[19] !== t2 || $[20] !== t3) {
    t8 = <div className={t2}>{t3}</div>;
    $[19] = t2;
    $[20] = t3;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <CopyIcon className="size-3.5 mr-1.5" />;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== handleCopy) {
    t10 = <Button size="sm" className="w-full mt-2" onClick={handleCopy}>{t9}Copy Version Info</Button>;
    $[23] = handleCopy;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== T0 || $[26] !== t10 || $[27] !== t4 || $[28] !== t5 || $[29] !== t8) {
    t11 = <T0 className={t4}>{t5}{t8}{t10}</T0>;
    $[25] = T0;
    $[26] = t10;
    $[27] = t4;
    $[28] = t5;
    $[29] = t8;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== T1 || $[32] !== t11 || $[33] !== t6 || $[34] !== t7) {
    t12 = <T1 open={t6} onOpenChange={t7}>{t11}</T1>;
    $[31] = T1;
    $[32] = t11;
    $[33] = t6;
    $[34] = t7;
    $[35] = t12;
  } else {
    t12 = $[35];
  }
  return t12;
};
AboutDialog.displayName = 'AboutDialog';